import { Grid, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { useSelector } from "react-redux"
import { center } from "../../../assets/css/theme/common"
import SubmitButton from "../../../components/button/SubmitButton"
import SearchBar from "../../../components/inputs/SearchBar"
import StockByProductCategory from "../../../components/layouts/inventory/StockByProductCategory"
import { permissions } from "../../../utils/constants"
import { Link, useParams } from "react-router-dom"
import { removeLastBracketFromName } from "../../../utils/helper"


const LifeTimeStockByCategoryUi = ({ listLoading, filters, setFilters, list, countsLoading, counts, fetchList, onCallBack }) => {
    const user = useSelector(state => state.user)
    const params = useParams()
    return (
        <>
            {/* <Box p={4}>
                <StockByProductCategory loading={countsLoading} data={counts} onClick={onCallBack} activeId={filters.productCategory} />
            </Box> */}
            <Box pt={4} >
                <Paper elevation={2} sx={{ width: "100%", padding: 4 }} >
                    <Box mb={4} sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography variant="h3" >List of Devices</Typography>
                        <Box pl={2} sx={{ display: "flex", alignItems: "flex-end", flexDirection: "column", flex: 1 }}>
                            <SearchBar placeholder={"Search by Box Id"} value={filters.search} onChange={(e) => { setFilters({ ...filters, search: e.target.value }) }} />


                        </Box>
                    </Box>


                    <TableContainer >


                        <Table aria-label="collapsible table">

                            <TableHead>
                                <TableRow>
                                    <TableCell>Box Id</TableCell>
                                    <TableCell>Mac Id</TableCell>
                                    <TableCell>Product Name</TableCell>
                                    <TableCell>Product Color</TableCell>
                                    <TableCell>Product Size</TableCell>

                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {listLoading &&

                                    <>
                                        <TableRow ><TableCell colSpan={6}  ><Skeleton width={"100%"} height={'50px'} /></TableCell></TableRow>
                                        <TableRow ><TableCell colSpan={6}  ><Skeleton width={"100%"} height={'50px'} /></TableCell></TableRow>
                                        <TableRow ><TableCell colSpan={6}  ><Skeleton width={"100%"} height={'50px'} /></TableCell></TableRow>

                                    </>
                                }
                                {!listLoading && list && list.result && list.result.length <= 0 && <TableRow >
                                    <TableCell colSpan={6} align="Center" ><Typography sx={{ ...center }} variant="h3" >No Data</Typography> </TableCell>
                                </TableRow>}
                                {!listLoading && list && list.result && list.result.length > 0 && list.result.map((row, index) => (
                                    <TableRow key={row._id}>
                                        <TableCell><Link to={`/dashboard/${params.usercode}/device/${row.boxId}`} > {row.boxId}</Link></TableCell>
                                        <TableCell>{row.macId}</TableCell>

                                        <TableCell >{row.product && removeLastBracketFromName(row.product.name)}</TableCell>
                                        <TableCell >{row.product.color && row.product.color.name}</TableCell>
                                        <TableCell >{row.product.type && row.product.type.name}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>



                        </Table>


                        {list &&  list.total > 0 && <TablePagination
                            rowsPerPageOptions={[10, 25]}
                            component="div"
                            count={list.total}
                            rowsPerPage={parseInt(filters.pageSize)}
                            page={parseInt(filters.pageNo) - 1}
                            onPageChange={(e, page) => { setFilters({ ...filters, 'pageNo': page + 1 }) }}
                            onRowsPerPageChange={(e) => { setFilters({ ...filters, 'pageSize': e.target.value }) }}
                        />}
                    </TableContainer>
                </Paper>
            </Box>

        </>
    )
}
export default LifeTimeStockByCategoryUi